// ModalFrame — backdrop + ESC handler + framer-motion fade shell.
// `align: "right"` switches from centred to slide-in drawer alignment.

import { useEffect } from 'react';
import { motion } from 'framer-motion';

const BACKDROP = 'rgba(15, 20, 25, 0.38)';

export function ModalFrame({ onClose, children, align }) {
  useEffect(() => {
    function onKey(e) { if (e.key === 'Escape') onClose(); }
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);
  return (
    <motion.div
      style={{
        position: 'fixed', inset: 0,
        background: BACKDROP,
        zIndex: 40,
        display: 'flex',
        alignItems: align === 'right' ? 'stretch' : 'center',
        justifyContent: align === 'right' ? 'flex-end' : 'center',
      }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.18 }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      {children}
    </motion.div>
  );
}
